import React from 'react';
import {
  Input
} from 'shared/components';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { AlertNotice } from 'shared/components';

const AcceptReview = ({
  setChecked,
  checked,
  hasError,
  setHasError,
  setServerError,
}) => {
  const { t } = useTranslation();
  const handleChange = () => {
    setChecked(!checked);
    if (hasError) {
      setHasError(false);
    }
    setServerError('');
  };
  const labelClass = hasError ? 'accept-error' : '';
  return (
    <div className="accept-review-container">
      {hasError &&
        <AlertNotice message={t('reviewAndCloseRoom.examineeStatus.confirm')} type="error"/>
      }
      <Input
        containerClassName="accept-review"
        type="checkbox"
        name="accept"
        id="accept"
        checked={checked}
        onChange={handleChange}
      >
        <label htmlFor="accept" className={labelClass}>
          {t('reviewAndCloseRoom.examineeStatus.accept')}
        </label>
      </Input>
    </div>
  );
};

export default AcceptReview;

AcceptReview.propTypes = {
  setChecked: PropTypes.func.isRequired,
  setHasError: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
};
